import { format } from '@formkit/tempo';
export const FORM_SESSION_KEY = 'form-data';
const FORMAT_DATE = 'YYYY-MM-DD';
export const syncFormStoreWithSession = (formStore) => {
    const saveFormDataToSession = () => {
        const { checkIn, checkOut, adultsCount, childrenCount, children } = formStore.getData();
        try {
            sessionStorage.setItem(FORM_SESSION_KEY, JSON.stringify({
                checkIn: format(checkIn, FORMAT_DATE),
                checkOut: format(checkOut, FORMAT_DATE),
                adultsCount,
                childrenCount,
                children,
            }));
        }
        catch (_a) { }
    };
    saveFormDataToSession();
    formStore.on('change', saveFormDataToSession);
    formStore.on('child-object-add', saveFormDataToSession);
    formStore.on('child-object-remove', saveFormDataToSession);
};
